import { AppRoutes } from 'containers/App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const adaptersRoot = 'adapters';

export const adaptersOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${adaptersRoot}`;

export const adapterNameParam = 'adapterName';
export const adaptersDetailRoute = `${adaptersOverviewRoute}/:${adapterNameParam}/edit`;
